import { track } from "./track";

export function trackPageView(pageName: string): void {
    track(`adsk:schema:${pageName}`);
}
